// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__4w1AF","content":"styles_content__1Dpbm","selectAll":"styles_selectAll__6f6IC"};